import React from "react";
import { motion } from "framer-motion";
import Slider from "react-slick";

// Hero & right content images
import heroImg from "../../assets/9.jpg";
import contentImg from "../../assets/m11.webp"; // starting image (right content)

// Import project images fa1/fa2 and backup factory visuals
import fa1 from "../../assets/fa1.jpeg";
import fa2 from "../../assets/fa2.jpeg";
import f3 from "../../assets/f3.jpeg";
import f4 from "../../assets/f4.jpeg";
import f5 from "../../assets/f5.jpeg";

const projectImages = [fa1, fa2, f3, f4, f5];

const Factory = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    pauseOnFocus: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="w-full">
      {/* Hero Section */}
      <div className="hero-fullwidth h-[430px] flex items-center justify-start px-6 md:px-12 hero-bg-color">

        <motion.div
          className="relative p-4 md:p-6 rounded-md"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <p className="text-white text-sm md:text-base mb-1 cursor-pointer">
            Home
          </p>
          <h1 className="text-white text-2xl md:text-4xl font-bold">
            Factory & Industrial Lifts
          </h1>
        </motion.div>
      </div>

      {/* Content Section */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 flex flex-col md:flex-row items-center gap-10">
        {/* Left Content */}
        <motion.div
          className="md:w-1/2 space-y-6"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: { opacity: 0, x: 80 },
            visible: { opacity: 1, x: 0, transition: { duration: 1 } },
          }}
        >
          <motion.p className="text-gray-700 text-lg leading-relaxed text-justify">
            Factories and industrial facilities require heavy-duty lifts and
            material handling solutions. These lifts ensure smooth movement of
            goods and machinery, increasing operational efficiency and safety
            standards within industrial environments.
          </motion.p>
          <motion.p className="text-gray-700 text-lg leading-relaxed text-justify">
            WVT Elevators provides specialized solutions for factories, including
            goods lifts, service elevators, and customized industrial lifts,
            tailored to the unique needs of your operations.
          </motion.p>
          <motion.p className="text-gray-700 text-lg leading-relaxed text-justify">
            Safety, durability, and compliance with industry standards are our
            top priorities. Regular inspections and maintenance ensure that your
            industrial lifts operate reliably and securely.
          </motion.p>
        </motion.div>

        {/* Right Image */}
        <motion.div
          className="md:w-1/2 w-full overflow-hidden rounded-2xl shadow-2xl"
          initial={{ opacity: 0, x: -80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <img
            src={contentImg}
            alt="Factory Lift"
            className="w-full h-[350px] md:h-[400px] object-cover rounded-2xl"
          />
        </motion.div>
      </div>

      {/* Projects Section */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-10"
          initial={{ opacity: 0, y: -80 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          SOME FACTORY PROJECTS
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: -120 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <Slider {...sliderSettings}>
            {projectImages.map((img, idx) => (
              <motion.div
                key={idx}
                className="px-2"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: idx * 0.1 }}
              >
                <img
                  src={img}
                  alt={`Project ${idx + 1}`}
                  className="w-full h-64 md:h-72 object-cover rounded-2xl shadow-lg"
                />
              </motion.div>
            ))}
          </Slider>
        </motion.div>
      </div>
    </div>
  );
};

export default Factory;
